import React, { useMemo } from 'react';
import { enGB } from 'date-fns/locale';
import type { Locale } from 'date-fns';

interface MonthGridPanelProps {
    selectedMonth: number;
    selectedYear:  number;
    onSelect: (month: number, year: number) => void;
    style?: React.CSSProperties;
    /** date-fns Locale used to localise the short month names. Defaults to enGB. */
    locale?: Locale;
}

export const MonthGridPanel = React.forwardRef<HTMLDivElement, MonthGridPanelProps>(
    ({ selectedMonth, selectedYear, onSelect, style, locale }, ref) => {
        const today      = new Date();
        const todayMonth = today.getMonth();
        const todayYear  = today.getFullYear();

        const loc = locale ?? enGB;
        const monthNames = useMemo(
            () => Array.from({ length: 12 }, (_, i) =>
                loc.localize!.month(i, { width: 'abbreviated' })
            ),
            [loc]
        );

        return (
            <div ref={ref} className="calendar-month-panel" style={style}>
                <div className="calendar-month-grid">
                    {monthNames.map((name, idx) => (
                        <button
                            key={idx}
                            className={[
                                'calendar-month-item',
                                idx === selectedMonth ? 'calendar-month-item--selected' : '',
                                idx === todayMonth && todayYear === selectedYear &&
                                    idx !== selectedMonth ? 'calendar-month-item--today' : '',
                            ].filter(Boolean).join(' ')}
                            onClick={() => onSelect(idx, selectedYear)}
                        >
                            {name}
                        </button>
                    ))}
                </div>
            </div>
        );
    }
);
MonthGridPanel.displayName = 'MonthGridPanel';